<template>
  <b-modal id="project-location-privacy-modal" size="lg" ref="projectLocationPrivacyModal" no-close-on-backdrop
    body-class="p-0" centered>
    <template slot="modal-header" class="mx-auto">
      <div>
        <h4 class="">Location Privacy</h4>
        <p class="mb-0">Who can view location coordinates in your project?</p>
      </div>
    </template>
    <template slot="default">
      <div class="p-3">
        <div>
          <h4>Managers, Observers, and people assigned to locations</h4>
          <p>
            Anyone with access to observe at a location, and whoever created the
            location, can always see the exact coordinates.
          </p>
        </div>
        <div>
          <h4>Everyone else (with access to the project)</h4>
          <p>
            Sees coordinates shifted to the center point within a grid cell of
            the size you select below. Larger cells make the original location
            harder to estimate. The right setting depends on your project.
            Consider how sensitive your locations are, such as private property,
            protected species, or participants' homes. Location
            <strong>names</strong> are always <strong>visible</strong>, so avoid
            putting addresses or other identifying details in the name.
          </p>
        </div>
        <b-form-group stacked v-slot="{ ariaDescribedby }">
          <b-form-radio-group id="radio-slots" v-model="localValue" :aria-describedby="ariaDescribedby"
            name="location-privacy-radios" size="lg">
            <b-form-radio :value="null"><span class="font-weight-bold">Exact Location</span><span class="pl-3">The
                original latitude and longitude will be visible.</span>
            </b-form-radio>
            <b-form-radio :value="4096"><span class="font-weight-bold">2.5 Square Kilometers (0.97
                mi<sup>2</sup>)</span><span class="pl-3">About the size of a neighborhood, a large park, or a mid-sized
                farm. <small>GBIF Cat 3</small></span>
            </b-form-radio>
            <b-form-radio :value="2048"><span class="font-weight-bold">10.1 Square Kilometers (3.91
                mi<sup>2</sup>)</span><span class="pl-3">About the size of a small town or a large farm.</span>
            </b-form-radio>
            <b-form-radio :value="1024"><span class="font-weight-bold">40.5 Square Kilometers (15.6
                mi<sup>2</sup>)</span><span class="pl-3">About the size of a mid-sized town or a large ranch.
              </span>
            </b-form-radio>
            <b-form-radio :value="512"><span class="font-weight-bold">162 Square Kilometers (62.6
                mi<sup>2</sup>)</span><span class="pl-3">About the size of a city or a very large ranch. Shows the
                general region without revealing where in it.
                <small>GBIF Cat 2</small></span>
            </b-form-radio>
            <b-form-radio :value="0" disabled><span class="font-weight-bold">No Location</span><span
                class="pl-3">Coordinates are not displayed at all.
                <span class="font-weight-bold">Currently unavailable.</span>
                <small>GBIF Cat 1</small></span>
            </b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </div>
      <div class="bg-warning py-2 px-3 text-center" v-if="localValue !== null">
        <i class="fa fa-triangle-exclamation mr-2"></i>Images may contain exact location coordinates. Consider turning
        Image Metadata Removal <b>On</b>.
      </div>
    </template>
    <template #modal-footer>
      <span class="mr-5">Save the Project to apply this change</span>
      <b-button size="md" variant="primary" @click="onClose()"> Done </b-button>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  components: {},
  props: {
    value: {
      type: Number,
      required: false,
    },
  },
  mounted() { },
  created() { },
  computed: {
    localValue: {
      get() {
        if (this.value === null || this.value === undefined) {
          return null;
        }
        return this.value;
      },
      set(newValue) {
        this.$emit("input", newValue);
      },
    },
    ...mapGetters({}),
  },
  methods: {
    ...mapActions({}),
    onClose() {
      // close modal
      this.$refs.projectLocationPrivacyModal.hide();
    },
  },
};
</script>

<style scoped lang="scss"></style>
